<template>
  <div class="view-image-container">
    <el-dialog
      :visible.sync="visible"
      :width="dialogWidth"
      :show-close="true"
      custom-class="image-viewer-dialog"
      @close="close"
      center
    >
      <div class="image-wrapper">
        <img
          :src="imageInfo.url"
          :style="{
            maxWidth: '100%',
            maxHeight: imageInfo.maxHeight + 'px'
          }"
          @error="handleImageError"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  name: 'ViewImage',
  data() {
    return {
      visible: false,
      dialogWidth: '50%',
      imageInfo: {
        url: '',
        maxHeight: 600
      }
    }
  },
  methods: {
    open(params) {
      this.imageInfo.url = params.url
      this.visible = true
      
      // 根据屏幕尺寸动态调整对话框大小
      const screenWidth = window.innerWidth
      if (screenWidth < 768) {
        this.dialogWidth = '90%'
        this.imageInfo.maxHeight = 400
      } else if (screenWidth < 1200) {
        this.dialogWidth = '70%'
        this.imageInfo.maxHeight = 500
      } else {
        this.dialogWidth = '50%'
        this.imageInfo.maxHeight = 600
      }
    },
    close() {
      this.visible = false
      this.imageInfo = {
        url: '',
        maxHeight: 600
      }
    },
    handleImageError(e) {
      e.target.src = '/img/noPhoto.jpg'
    }
  }
}
</script>

<style lang="scss" scoped>
.view-image-container {
  ::v-deep .image-viewer-dialog {
    .el-dialog__header {
      padding: 10px;
    }
    
    .el-dialog__body {
      padding: 20px;
      text-align: center;
    }
    
    .image-wrapper {
      display: flex;
      justify-content: center;
      align-items: center;
      min-height: 200px;
      
      img {
        display: block;
        width: auto;
        height: auto;
        object-fit: contain;
        border-radius: 4px;
      }
    }
  }
}
</style>

<style lang="scss">
/* el-dialog 默认渲染在 body 下的 portal 中，scoped 样式无法命中，
   需用全局样式保证流程图等图片在弹窗内水平垂直居中 */
.image-viewer-dialog {
  .el-dialog__body {
    padding: 20px;
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    overflow: auto;
  }

  .image-wrapper {
    display: flex !important;
    justify-content: center !important;
    align-items: center !important;
    width: 100%;
    min-height: 200px;
  }

  .image-wrapper img {
    display: block;
    max-width: 100%;
    max-height: 600px;
    object-fit: contain;
    border-radius: 4px;
  }
}
</style>